import { removeNulls, safeParseNullDefault } from 'shouldve-been-js';
import DepartmentLink from './DepartmentLinkModel';

class UserDepartmentLink {

    private _userId: string;
    private _departmentLinks: DepartmentLink[];

    public constructor(userId: string, departmentLinks: DepartmentLink[]) {

        this._userId = userId;
        this._departmentLinks = departmentLinks;
    }

    public get userId(): string {
        return this._userId;
    }

    public set userId(value: string) {
        this._userId = value;
    }

    public get departmentLinks(): DepartmentLink[] {
        return this._departmentLinks;
    }

    public set departmentLinks(value: DepartmentLink[]) {
        this._departmentLinks = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(key: string, json: any): UserDepartmentLink | null {

        const userId: string = key;

        if (!Array.isArray(json)) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
        const departmentLinks: (DepartmentLink | null)[] = json.map((jsonObject: any) => {
            return DepartmentLink.fromJson(jsonObject);
        });   

        return new UserDepartmentLink(userId, removeNulls(departmentLinks));
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): UserDepartmentLink | null {

        const userId: string | null = safeParseNullDefault<string>(object?._userId, '');

        if (userId === null || userId === '') {
            return null;
        }
        
        if (!Array.isArray(object?._departmentLinks)) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        const departmentLinks: (DepartmentLink | null)[] = object._departmentLinks.map((departmentLinkObject: any) => {
            return DepartmentLink.fromIndexedDB(departmentLinkObject);
        });   

        return new UserDepartmentLink(userId, removeNulls(departmentLinks));
    }
}

export default UserDepartmentLink;